module.exports = __webpack_public_path__ + "static/img/contact2.b305c13.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/contact2.png
// module id = 900
// module chunks = 1